<template>
  <v-card
    elevation="0"
    class="widget"
    :class="{
      'widget--project': formatViewData.isProjectStatus,
      'widget--work': formatViewData.isWork,
      'widget--finance': formatViewData.isFinance,
    }"
    :color="formatViewData.isProjectStatus ? 'transparent' : null"
  >
    <div
      class="widget__head px-5 py-4 f18 d-grid fw500"
      :class="{ 'widget__head--finance': formatViewData.isFinance }"
    >
      <div class="widget__head__name">{{ formatViewData.title }}</div>
      <div class="widget__head__info">
        {{
          formatViewData.isWork !== true
            ? (reports ? commonWidgetReport?.count || '0' : formatViewData?.countAll || '0') +
              ' ' +
              localStorage.translations.pages.common.measure['piece']
            : ''
        }}
      </div>
    </div>
    <div
      v-if="
        (widgetData?.length > 0 && formatViewData.isProjectStatus) ||
        (showEmployeesData && formatViewData.isWork) ||
        (formatViewData.isFinance && (((widgetData && widgetData.total > 0) || reports) || dataKey === 'invoices'))
      "
      ref="widget__body"
      class="widget__body"
      :class="{ 'widget__body--scroll': formatViewData.isProjectStatus }"
    >
      <template v-if="formatViewData.isProjectStatus && widgetData?.length > 0">
        <template v-for="(dataItem, dataItemKey) in widgetData">
          <div
            class="widget__body__item px-5 py-4 f16"
            :key="dataItemKey"
            :id="dataItemKey"
            :ref="'item_' + dataItemKey"
            :class="{
              pointer: dataItem?.projects?.length,
              'item--active': selected === dataItemKey,
              'item--active--next': selected === dataItemKey - 1,
              'widget__body__item--last': dataItemKey == widgetData.length - 1,
            }"
            @click="
              selected === dataItemKey ? (selected = -2) : (selected = dataItemKey),
                scrollToItem(dataItemKey)
            "
          >
            <div class="d-flex gap-4 align-center">
              <v-icon
                v-if="dataItem?.projects?.length"
                class="ml-n2 mr-n2"
                :class="{
                  widget__body__item__icon: true,
                  'widget__body__item__icon--active': selected === dataItemKey,
                }"
              >
                mdi-menu-right
              </v-icon>
              <div class="avatar">
                <img
                  :src="
                    dataItem.logo
                      ? apiDomain + '/min/' + dataItem.logo
                      : require('@/assets/svg/ImageNotFound.svg')
                  "
                  alt="logo"
                />
              </div>
              {{ dataItem.name }}
            </div>
            <div>
              {{
                dataItem.project_count +
                ' ' +
                localStorage.translations.pages.common.measure['piece']
              }}
            </div>
          </div>
          <v-expand-transition :key="dataItemKey + '_projects'">
            <v-card
              v-show="dataItem?.projects?.length && selected === dataItemKey"
              class="ml-5"
              flat
              tile
              :class="{
                'item--active': dataItemKey == widgetData.length - 1,
              }"
            >
              <div class="widget__body__item item--inner header font-weight-bold px-5 py-4">
                <div class="f16">
                  {{ localStorage.translations.pages.common.text.project_name }}
                </div>
                <div class="f16">
                  {{
                    dataKey === 'unreported_work'
                      ? localStorage.translations.pages.common.text['unreported_amount'] ||
                        'Unreported amount'
                      : localStorage.translations.pages.common.text.project_end_date
                  }}
                </div>
              </div>
              <div
                v-for="(itemProject, ip) in dataItem.projects"
                :key="ip"
                class="widget__body__item item--inner item-body px-5 py-4 pointer"
                @click="openProjectRow(itemProject)"
              >
                <div class="f16 mh20">{{ itemProject.name }}</div>
                <div class="f16 mh20">
                  {{
                    dataKey === 'unreported_work'
                      ? $formatCurrency(itemProject.unreported_amount || 0) + ' €'
                      : dateFormat(itemProject.end_date)
                  }}
                </div>
              </div>
            </v-card>
          </v-expand-transition>
        </template>
      </template>
      <HomeWidgetToday v-else-if="formatViewData.isWork" :data="widgetData" />
      <HomeWidgetFinance
        v-else-if="formatViewData.isFinance && (((widgetData && widgetData.total > 0) || reports) || dataKey === 'invoices')"
        :data="formatViewData.data"
        :clearData="widgetData"
        :show-reports="reports"
        :show-invoices="dataKey === 'invoices'"
        :initial-period="initialPeriod"
        @invoices-updated="onInvoicesUpdated"
      />
      <Plug class="plug" v-else />
      <div class="d-flex justify-end" v-if="formatViewData.isWork || formatViewData.isFinance">
        <button class="px-5 py-2" @click="formatViewData.btnClick && formatViewData.btnClick()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M13 19L20 12L13 5"
              stroke="#277FAF"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 12H4"
              stroke="#277FAF"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
    <Plug v-else />
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import HomeWidgetToday from './HomeWidgetToday'
import HomeWidgetFinance from './HomeWidgetFinance'
import Plug from "components/Plug.vue";

export default {
  name: 'HomeWidget',
  components: {
    Plug,
    HomeWidgetToday,
    HomeWidgetFinance,
  },
  props: {
    data: {
      type: [Array, Object],
      default: null,
    },
    dataKey: {
      type: String,
      default: '',
    },
    reports: Boolean,
    initialPeriod: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selected: -2,
    showEmployeesData: false,
    widgetData: null,
    allFields: {
      new: 'var(--v-primary-lighten1)',
      in_progress: 'var(--v-primary-base)',
      approved: 'var(--v-success-lighten5)',
      sent: 'var(--v-warning-lighten1)',
      viewed: 'var(--v-warning-base)',
      expired: 'var(--v-error-base)',
      signed: 'var(--v-success-base)',
    },
  }),
  computed: {
    ...mapState(['apiDomain']),
    ...mapGetters('workClientProjectsClientBills', ['workClientProjectsClientBillStatuses']),
    ...mapGetters('commonWidgets', ['commonWidgetReport']),
    dataCountAll() {
      return this.widgetData && this.widgetData.length > 0
        ? this.widgetData.reduce((sum, elem) => {
            return sum + elem.project_count
          }, 0)
        : 0
    },
    formatViewData() {
      let result = {
        title: '',
        isProjectStatus: false,
        isWork: false,
        isFinance: false,
        countAll: this.dataCountAll || 0,
        data: null,
      }
      switch (this.dataKey) {
        case 'projects_in_progress':
          result.title =
            this.localStorage.translations.pages['setting-push_notifications'].main.projects
          result.isProjectStatus = true
          break
        case 'projects_expiring':
          result.title = this.localStorage.translations.pages.common.text['finishing_projects']
          result.isProjectStatus = true
          break
        case 'unreported_work':
          result.title = this.localStorage.translations.pages.common.text['unreported_work']
          result.isProjectStatus = true
          break
        case 'employees_status':
          result.title = this.localStorage.translations.pages.common.text['today_in_work']
          result.isWork = true
          result.countAll = null
          result.btnClick = () =>
            this.$router.push({ name: 'employeesAll', query: { worker_status: 'free_workers' } })
          break
        case 'reports':
          result.title = this.localStorage.translations.pages['projects'].pages.reports
          result.isFinance = true
          result.data = this.formatDataReports
          result.countAll = this.widgetData?.count ?? 0
          result.btnClick = () => this.$router.push({ name: 'ProjectsReports' })
          break
        case 'invoices':
          result.title = this.localStorage.translations.pages.finance.pages.invoice
          result.isFinance = true
          result.data = this.formatDataInvoices
          result.countAll = this.widgetData?.total ?? 0
          result.btnClick = () => this.$router.push({ name: 'financeInvoice' })
          break
      }
      return result
    },
    formatDataInvoices() {
      let result = []
      if (this.dataKey === 'invoices' && this?.widgetData?.statuses && Object.keys(this.widgetData.statuses).length > 0) {
        this.workClientProjectsClientBillStatuses.forEach((element) => {
          if (this.widgetData.statuses[element.status] !== undefined && this.widgetData.statuses[element.status]['count'] > 0)
            result.push({
              name: this.localStorage.translations.pages.finance['invoice-status'][
                element.translation
                ],
              color: element.color,
              count: this.widgetData.statuses[element.status]['count'],
              text: this.$formatCurrency(this.widgetData.statuses[element.status]['total_price']) + ' €',
              total_price: this.widgetData.statuses[element.status].total_price,
            })
        })
      }
      return result
    },
    widgetNames() {
      let result = []
      let list = ['new', 'sent', 'viewed', 'expired', 'approved', 'signed']
      for (let i in list)
        result.push({
          name: list[i],
          color: this.allFields[list[i]],
        })
      return result
    },
    formatDataReports() {
      let total_result = []
      let result = []
      let result_inner = []
      if (this.dataKey === 'reports' && this?.commonWidgetReport?.statuses) {
        let temp = this.commonWidgetReport && this.commonWidgetReport.statuses
        let temp_inner =
          this.commonWidgetReport.statuses && this.commonWidgetReport.statuses.in_progress.statuses
        let names = this.widgetNames
        for (let n in names) {
          let name = names[n].name
          let color = names[n].color
          if (temp && temp[name] && temp[name].price > 0) {
            result.push({
              name: this.localStorage.translations.pages.projects['reports_table'][name] || name,
              color: color,
              count: temp[name].price,
              text: this.$formatCurrency(temp[name].price) + ' €',
              amount: this.$formatCurrency(temp[name].price),
            })
          }
          if (temp_inner && temp_inner[name] && temp_inner[name].price > 0) {
            result_inner.push({
              name: this.localStorage.translations.pages.projects['reports_table'][name] || name,
              color: color,
              count: temp_inner[name].price,
              text: this.$formatCurrency(temp_inner[name].price) + ' €',
              amount: this.$formatCurrency(temp_inner[name].price),
            })
          }
        }
      }
      total_result = result.concat(result_inner)
      return total_result
    },
  },
  created() {
    this.widgetData = this.data
    this.checkUserStatusesData()
  },
  updated() {
    this.checkUserStatusesData()
  },
  watch: {
    data: {
      handler(newValue) {
        this.widgetData = newValue
      },
      deep: true,
    },
  },
  methods: {
    dateFormat(string) {
      let arr = string.split('-')
      return `${arr[2]}.${arr[1]}.${arr[0]}`
    },
    scrollToItem(data) {
      if (this.$refs.widget__body) {
        setTimeout(() => {
          this.$refs.widget__body.scrollTo({
            top: 61 * data,
            behavior: "smooth"
          })
        }, 100)
      }
    },
    openProjectRow(itemProject) {
      if (this.dataKey === 'unreported_work') {
        const query = {}
        if (itemProject.unreported_start_date) {
          query.unreported_start_date = itemProject.unreported_start_date
        }
        if (itemProject.unreported_end_date) {
          query.unreported_end_date = itemProject.unreported_end_date
        }
        this.$router.push({ name: 'timeControlShowReports', params: { id: itemProject.id }, query })
        return
      }
      this.$router.push({ name: 'ProjectsProjectShow', params: { id: itemProject.id } })
    },
    checkUserStatusesData() {
      if (this.formatViewData.isWork) {
        let temp = Object.values(this.widgetData || {})
        for (let t in temp) {
          if (temp[t] > 0) {
            this.showEmployeesData = true
            return
          }
        }
        this.showEmployeesData = false
      }
    },
    onInvoicesUpdated(data) {
      this.widgetData = data
    },
  },
}
</script>

<style scoped lang="scss">
.widget {
  --border-bottom: 1px solid #ebeff2;
  --template-column: auto 20%;
  border-radius: 10px;
  width: 100%;
  display: grid;
  grid-template-rows: max-content auto;
  &__head {
    background-color: white;
    grid-template-columns: var(--template-column);
    text-align: start;
    border-bottom: var(--border-bottom);
    align-items: center;

    &--finance {
      grid-template-columns: auto max-content;
    }
  }

  &__body {
    &--scroll {
      overflow: auto;
      max-height: 305px;
    }

    &__item {
      display: grid;
      grid-template-columns: var(--template-column);
      align-items: center;
      text-align: start;
      background-color: white;
      border-bottom: var(--border-bottom);

      &--last {
        border-bottom: none;
      }

      &__icon {
        &--active {
          transform: rotate(90deg);
        }
      }
    }

    .avatar {
      --avatar-size: 28px;
      width: var(--avatar-size);
      height: var(--avatar-size);
      border-radius: 50%;
      background-color: #ffffff;
      border: 1px solid #dbdbdb;

      img,
      svg {
        border-radius: inherit;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  // &--project {
  //   max-width: 460px;
  //   min-width: 330px;
  // }
  // &--work {
  //   max-width: 400px;
  //   min-width: 330px;
  // }
  // &--finance {
  //   max-width: 580px;
  //   min-width: 330px;
  // }
}

.pointer {
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
}

.item {
  &--active {
    border-bottom-left-radius: 10px !important;

    &--next {
      border-top-left-radius: 10px;
    }
  }
}

.item--inner {
  display: grid;
  grid-template-columns: 2fr 1fr;
}
.item-body {
  &:hover {
    background-color: rgba(#f2f2f2, 0.5);
  }
}
.header {
  background-color: #f2f2f2;
  border: 1px solid rgba(217, 215, 215, 0.8);
}

.mh20 {
  line-height: 1.8;
}
.plug {
  background-color: white;
  overflow: hidden;
}
:deep() .plug__text {
  font-size: 32px !important;
  margin-bottom: 10px;
}
:deep() .plug__icon {
  max-height: 240px;
  margin-top: 10px;
}
</style>
